<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Licencia" resource="licencias" primaryKey="idlicencia" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" :readonly="readonly"/>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CardRecord from "@/components/Cards/CardRecord.vue";
import LicenciaService from "@/services/licencia.service";
import { licencia } from "@/models/licencia";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: licencia,
      service: LicenciaService
    }
  },

  computed: {
    ...mapState({
      userInfo: state => state.auth.user
    }),
    readonly() {
      const roles = this.userInfo?.roles || [];
      return !roles.includes('admin') && !roles.includes('personal');
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        LicenciaService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
